import { render, staticRenderFns } from "./_betListESports2.vue?vue&type=template&id=e702ad36&lang=pug&"
import script from "./_betListESports2.vue?vue&type=script&lang=js&"
export * from "./_betListESports2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports